import { useState } from 'react'
import Header from './Header'
import Sider from './Sider'
import Content from './Content'
import { $consts } from 'src/plugins'
import { useEvt } from 'src/hooks'

const Main = () => {
  const [collapsed, setCollapsed] = useState(false)
  useEvt($consts['EVT/SIDER_COLLAPSED'], (val: boolean) => {
    setCollapsed(val)
  })

  return (
    <div className={`main ${collapsed ? 'sider-collapse' : 'sider-expand'}`}>
      <div className='main__header'><Header /></div>
      <div className='main__body with-header'>
        <div className='main__sider'><Sider /></div>
        <div className='main__content'><Content /></div>
      </div>
    </div>
  )
}

export default Main